import React from "react";
import "../css/Login.css";
/**
 * Login
 */
class Login extends React.Component {
  static displayName = "Login";
  static defaultProps = {};

  /**
   * @override
   */
  render() {
    return <div />; // Let silverstripe do the rendering
  }
}
export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login.js